module.exports = __webpack_public_path__ + "media/svg-new/icon-right-circle-67c0dd51.svg";